export function asArray<T>(val: readonly T[]): readonly T[]
export function asArray<T>(val: T[]): T[]
export function asArray<T>(val: T): T[]
export function asArray<T>(val: T): unknown {
  return Array.isArray(val) ? val : [val]
}
